import React from "react";
import { Skeleton } from "@mui/material";
import "./ClientCardsSkeleton.css";

export default function ClientCardsSkeleton({ variant = "default", count = 6 }) {
  const isV2 = variant === "v2";

  return (
    <div className="client-card-skeleton-grid" aria-hidden="true">
      {Array.from({ length: count }).map((_, index) => (
        <div
          className={`client-card-skeleton ${
            isV2 ? "client-card-skeleton-v2" : ""
          }`}
          key={`client-card-skeleton-${index}`}
        >
          <div className="client-card-skeleton-header">
            <div className="client-card-skeleton-title">
              <Skeleton variant="rounded" width={58} height={18} />
              <Skeleton variant="text" width="70%" height={20} />
              <Skeleton variant="text" width="48%" height={18} />
            </div>
            <Skeleton variant="circular" width={54} height={54} />
          </div>

          <div className="client-card-skeleton-body">
            <Skeleton variant="rounded" height={isV2 ? 52 : 44} />
            <Skeleton variant="rounded" height={isV2 ? 52 : 44} />
            <Skeleton variant="rounded" height={isV2 ? 52 : 44} />
            <Skeleton variant="rounded" height={isV2 ? 52 : 44} />
            {isV2 && (
              <>
                <Skeleton variant="rounded" height={52} />
                <Skeleton variant="rounded" height={52} />
              </>
            )}
          </div>

          <Skeleton variant="rounded" height={28} />
        </div>
      ))}
    </div>
  );
}
